import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, useDebouncedCallback } from 'shared/hooks';
import { selectLocationSwitcherData } from 'shared/selectors/geo';
import { makeAutocompleteSearch, selectCityBySuggest, selectRegion } from 'shared/thunks/geo/locationSwitcher';
import { ILocation } from 'shared/types/location';
import { IGeoSuggestItem } from 'shared/types/geoSuggest';
import { LocationSwitcherAutocomplete } from '../../../../../../packages/GeoComponents';

export const LocationSwitcherAutocompleteContainer = () => {
  const { autocompleteSuggestions, isAutocompleteLoading } = useSelector(selectLocationSwitcherData);

  const dispatch = useAppDispatch();

  const handleValueChange = useDebouncedCallback((value: string) => {
    if (value.length > 2) {
      dispatch(makeAutocompleteSearch(value));
    }
  });

  const handleSelect = useCallback(
    (suggestion: IGeoSuggestItem<ILocation>) => {
      const { value: location } = suggestion;

      if (location.parentId) {
        dispatch(selectCityBySuggest(location));
      } else {
        dispatch(selectRegion(location));
      }
    },
    [dispatch],
  );

  return (
    <LocationSwitcherAutocomplete
      suggestions={autocompleteSuggestions}
      loading={isAutocompleteLoading}
      onValueChange={handleValueChange}
      onSelect={handleSelect}
    />
  );
};
